import module from 'nominas/sumario/module.js'

const schema = {}

export class NominasValidacionService {
  constructor ($q, $http) {
    this.$q = $q
    this.$http = $http
  }

  obtenerIndice (proyectoId, nominaTipoId, fecha) {
    return this.$http.get('/api/nominas/indice', {
      params: {proyecto_id: proyectoId, nomina_tipo_id: nominaTipoId, fecha: fecha.toYMD()},
      schema,
    })
  }

  idNominaExiste (proyectoId, nominaId) {
    return this.$http.get('/api/nominas/nomina/existe', {
      params: {proyecto_id: proyectoId, nomina_id: nominaId},
    })
      .then(() => this.$q.reject(true))
      .catch(() => false)
  }
}

module.service('NominasValidacion', NominasValidacionService)



// WEBPACK FOOTER //
// ./src/nominas/sumario/services/NominasValidacion.js